import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { useResourceType } from "hooks/ajax/useAjax";
import { useDetailOrderAttachments } from "hooks/order/useOrder";
import {
  useDeleteResource,
  useDownloadResources,
  useResourceGlobalPreview,
} from "hooks/resource-global/useResourceGlobal";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Lightbox from "react-image-lightbox";
const OrderImageList = ({ orderId }) => {
  const [isPreviewImage, setIsPreviewImage] = useState(false);
  const [resourceId, setResourceId] = useState(undefined);
  const {
    data: listImage,
    refetch: fetchListImage,
    isLoading: isListImageLoading,
  } = useDetailOrderAttachments({
    orderId: orderId,
  });
  const { data: resourceType } = useResourceType();
  const { data: resourceData, refetch: fetchResourceGlobalPreview } =
    useResourceGlobalPreview({
      resourceId: resourceId,
    });
  const downloadResource = useDownloadResources();
  const deleteResource = useDeleteResource(() => {
    fetchListImage();
  });

  const columnTable = [
    {
      dataField: "no",
      text: "#",
      formatter: (cell, row, enumObject) => {
        return `${enumObject + 1}`;
      },
    },
    {
      dataField: "maker_date",
      text: "Thời gian",
      sort: true,
      formatter: (cell, row, enumObject) => {
        return moment(parseInt(cell) * 1000).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    {
      dataField: "maker_name",
      text: "Người tải lên",
      sort: true,
    },
    {
      dataField: "storage_type",
      text: "Loại tập tin",
      sort: true,
      formatter: (cell, row, enumObject) => {
        return resourceType[cell] || "";
      },
    },
  ];

  const rowActionList = [
    {
      actionAccess: "",
      icon: <i className="fas fa-eye fa-lg text-primary ms-2" />,
      text: "Xem hình ảnh",
      onClick: row => handlePreviewImage(row),
    },
    {
      actionAccess: "",
      icon: <i className="fas fa-download fa-lg text-success ms-2" />,
      text: "Tải hình",
      onClick: row => downloadImage(row),
    },
    {
      actionAccess: "",
      icon: <i className="fas fa-trash fa-lg text-danger ms-2" />,
      text: "Xoá hình",
      onClick: row => deleteResource.mutate(row.id),
    },
  ];

  useEffect(() => {
    if (orderId) {
      fetchListImage();
    }
  }, [orderId]);

  useEffect(() => {
    if (resourceId) {
      fetchResourceGlobalPreview();
    }
  }, [resourceId]);

  const handlePreviewImage = row => {
    setResourceId(row.id);
    setIsPreviewImage(true);
  };

  const downloadImage = row => {
    downloadResource.mutate({
      name: `${row.storage_type}_${row.id}`,
      id: row.id,
    });
  };

  return (
    <>
      <RemoteDataTable
        keyField="id"
        data={listImage || []}
        searchSticky
        columns={columnTable}
        isShowRowIndex={false}
        isShowSearchAll={false}
        isShowPagination={false}
        classNameTable={"order-image-list-table"}
        listRowAction={rowActionList}
        loading={isListImageLoading}
      ></RemoteDataTable>
      {isPreviewImage && resourceData && (
        <Lightbox
          enableZoom={true}
          onCloseRequest={() => setIsPreviewImage(false)}
          mainSrc={resourceData}
        />
      )}
    </>
  );
};

export default OrderImageList;
